<template>
  <v-main class="page-form-main-chat">
    <portal to="app-bar">
      <v-app-bar
        app
        color="secondary"
        dark
      >
        <v-btn
          icon
          @click="$router.go(-1)"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title v-if="internalProject">
          {{ internalProject.name }}
        </v-toolbar-title>
      </v-app-bar>
    </portal>

    <v-container
      ref="chatContainer"
      class="chat-container"
    >
      <message
        :messages="messages"
        @imageLoad="scrollToEnd"
      />
    </v-container>

    <v-footer app>
      <v-row>
        <v-col :class="inputHints.length ? 'pb-0' : 0">
          <v-textarea
            v-model="message"
            append-icon="mdi-paperclip"
            auto-grow
            filled
            clear-icon="mdi-close-circle"
            clearable
            rows="1"
            :hide-details="!inputHints.length"
            :messages="inputHints"
            @click:append="uploadFile"
          />
          <input
            ref="uploadInput"
            type="file"
            class="d-none"
            @input="fileChanged"
          >
        </v-col>
        <v-col cols="auto">
          <v-btn
            :disabled="(!message && !attachment) || sending"
            color="primary"
            fab
            @click="sendMessage"
          >
            <v-icon>mdi-send</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>
  </v-main>
</template>

<script>
import axios from 'axios';
import Message from '@/components/Chat/Message';

export default {
  components: {
    Message
  },
  props: {
    project: { type: Object, default: () => null }
  },
  data: () => ({
    routeProject: null,
    sending: false,
    message: '',
    messages: [],
    inputHints: [],
    attachment: null
  }),
  computed: {
    internalProject () {
      return this.project || this.routeProject || null;
    }
  },
  watch: {
    internalProject (p) {
      this.getMessages();
    }
  },
  mounted () {
    this.getMessages();
    if (this.$route.params.id) {
      this.$pouch.get('' + this.$route.params.id, {}, 'projects').then((doc) => {
        this.routeProject = doc;
      });
    }
  },
  methods: {
    uploadFile () {
      this.attachment = null;
      this.$refs.uploadInput.value = null;
      this.$refs.uploadInput.click();
    },
    fileChanged (e) {
      const files = e.target.files;
      if (files.length) {
        this.inputHints = [this.$t('form.chat.attachment') + files[0].name];
        this.attachment = files[0];
      }
    },
    async getMessages (page = 1) {
      if (!this.internalProject) return;

      const { data } = await axios.get(`/project/${this.internalProject._id}/message`, {
        params: { page }
      });
      if (page === 1) {
        this.messages = data.data.reverse();
      } else {
        this.messages = this.messages.concat(data.data.reverse());
      }

      this.scrollToEnd();
    },
    async sendMessage () {
      this.sending = true;
      let formData;

      if (this.attachment) {
        formData = new FormData();
        formData.append('attachment', this.attachment, this.attachment.name);
        formData.append('message', this.message);
      } else {
        formData = {
          message: this.message
        };
      }

      try {
        const { data } = await axios.post(`/project/${this.internalProject._id}/message`, formData);
        this.messages.push(data);
        this.attachment = null;
        this.inputHints = [];

        this.scrollToEnd();
      } catch (e) {
        if (e.response && e.response.data && e.response.data.errors) {
          alert(Object.values(e.response.data.errors).join('\n'));
        }
      }

      this.sending = false;
      this.message = '';
    },
    scrollToEnd () {
      this.$nextTick(() => {
        window.scrollTo(0, document.body.scrollHeight);
        setTimeout(() => {
          window.scrollTo(0, document.body.scrollHeight);
        }, 200);

        if (document.body.scrollHeight <= window.innerHeight) {
          const scrollDown = setInterval(() => {
            if (document.body.scrollHeight > window.innerHeight) {
              window.scrollTo(0, document.body.scrollHeight);
              clearInterval(scrollDown);
            }
          }, 2);
          setTimeout(() => {
            clearInterval(scrollDown);
          }, 200);
        }
      });
    }
  }
};
</script>

<style lang="scss">
.v-input__icon--append {
  cursor: pointer;
}
.page-form-main-chat {
  .v-text-field__details {
    margin-bottom: 0 !important;
  }
}
.typer{
  box-sizing: border-box;
  display: flex;
  align-items: center;
  bottom: 0;
  height: 4.9rem;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -5px 10px -5px rgba(0,0,0,.2);
}
.typer input[type=text]{
  position: absolute;
  left: 2.5rem;
  padding: 1rem;
  width: 80%;
  background-color: transparent;
  border: none;
  outline: none;
  font-size: 1.25rem;
}
.message{
  margin-bottom: 3px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  &.own {
    align-items: flex-end;
  }
}
.message.own .content{
  background-color: lightskyblue;
}
.chat-container .username{
  font-size: 18px;
  font-weight: bold;
}
.chat-container .content{
  padding: 8px;
  background-color: lightgreen;
  border-radius: 10px;
  display:inline-block;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.2), 0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12);
  max-width: 80%;
  word-wrap: break-word;
  }
@media (max-width: 480px) {
  .chat-container .content{
    max-width: 80%;
  }
}
</style>
